<template>
  <div>
    <div
      class="row col-12 q-gutter-sm q-mt-lg q-ml-lg text-brand-5 text-weight-bold container-input"
    >
      <div
        v-if="botaoTipo == 'criar'"
        class="row col-12 q-gutter-x-sm container-input"
      ></div>
    </div>
    <div class="container-table">
      <q-table
        :columns="columns"
        :rows="listaCas"
        flat
        dense
        table-header-class="bg-accent text-weight-bold"
        hide-pagination
        v-model:pagination="pagination"
        :loading="loading"
        class="tabela-tamanho-fixo"
        :filter="busca"
        @request="paginarTabela"
        :grid="$q.screen.lt.sm"
        color="primary"
        hide-bottom
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Lista de CAs Criados</span
          >
        </template>
        <template v-slot:top-right>
          <div class="row items-center q-gutter-sm">
            <q-btn
              dense
              outlined
              label="Adicionar CA"
              class="q-mt-sm btn"
              no-caps
              color="positive"
              icon="add_circle_outline"
              flat
              @click="abrirModalCriarCa"
            >
            </q-btn>
          </div>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12 items-center justify-between">
                <span class="col-9 q-ml-sm"
                  ><strong>Codigo: </strong>{{ props.row.code }}</span
                >
              </div>
              <div class="row col-12 items-center justify-end">
                <span class="q-ml-sm row items-center"
                  ><strong>Status: </strong>
                  <div
                    v-if="props.row.status == 'Válido'"
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div style="width: fit-content" class="text-brand-5">
                      {{ props.row.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div style="width: fit-content">
                      {{ props.row.status }}
                    </div>
                  </div></span
                >
                <div></div>
              </div>
              <div class="row col-12 items-center justify-between">
                <span class="col-9 q-ml-sm"
                  ><strong>Vencimento: </strong
                  >{{
                    props.row.expires_in
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}</span
                >
                <div></div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigoCa="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-vencimento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.expires_in?.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td>
            <div
              v-if="props.row.status == 'Válido'"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ props.row.status }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ props.row.status }}
              </div>
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-btn="props">
          <q-td>
            <q-btn
              icon="edit"
              color="brand-1"
              size="sm"
              flat
              dense
              class="q-mt-sm"
              @click="abrirModalEditarCa(props.row)"
            >
              <q-tooltip anchor="top middle" self="bottom middle">
                Editar este CA
              </q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="loading"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <!-- Modal de Validação de CA -->
    <CaValidationModal
      v-model="isModalOpen"
      :ca-number="currentCaNumber"
      :ca-id="currentCaId"
      @update:model-value="closeValidationModal"
      @ca-updated="handleCaUpdated"
    />
  </div>
  <q-dialog v-model="modalCa" position="right" full-height>
    <q-card style="width: 400px; max-width: 90vw" class="q-pa-md">
      <q-card-section>
        <div class="text-h6">
          {{ modoModal === "criar" ? "Criar novo CA" : "Editar CA Existente" }}
        </div>
      </q-card-section>

      <q-card-section>
        <!-- Modo CRIAR -->
        <div v-if="modoModal === 'criar'">
          <div class="q-mb-sm">Código do CA</div>
          <q-input v-model="dados.codigo" outlined dense class="q-mb-md" />

          <div class="q-mb-sm">Validade</div>
          <q-input
            v-model="dados.dataExpiracao"
            outlined
            dense
            mask="##/##/####"
          >
            <template v-slot:prepend>
              <q-icon name="event">
                <q-popup-proxy>
                  <q-date
                    v-model="dados.dataExpiracao"
                    mask="DD/MM/YYYY"
                    :locale="myLocale"
                  />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <div class="row q-gutter-sm q-mt-md">
            <q-btn
              label="Validar CA"
              color="secondary"
              icon="verified"
              outline
              :disable="dados.codigo === ''"
              @click="validateCaNumber(dados.codigo)"
            />

            <q-btn
              label="Salvar"
              color="positive"
              icon="add_circle"
              outline
              @click="adicionarCA"
            />
          </div>
        </div>

        <!-- Modo EDITAR -->
        <div v-if="modoModal === 'editar'">
          <div class="q-mb-sm">Selecionar CA</div>
          <q-select
            v-model="caSelecionadoEditar"
            outlined
            dense
            use-input
            hide-selected
            fill-input
            :options="options"
            @filter="filterFn"
            class="q-mb-md"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section>Sem resultados</q-item-section>
              </q-item>
            </template>
          </q-select>

          <div class="q-mb-sm">Validade</div>
          <q-input
            v-model="dados.dataAtualizar"
            outlined
            dense
            mask="##/##/####"
          >
            <template v-slot:prepend>
              <q-icon name="event">
                <q-popup-proxy>
                  <q-date
                    v-model="dados.dataAtualizar"
                    mask="DD/MM/YYYY"
                    :locale="myLocale"
                  />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <div class="row q-gutter-sm q-mt-md">
            <q-btn
              label="Validar CA"
              color="secondary"
              icon="verified"
              outline
              :disable="!caSelecionadoEditar"
              @click="
                validateCaNumber(
                  caSelecionadoEditar?.label,
                  caSelecionadoEditar?.value
                )
              "
            />
            <q-btn
              outline
              label="Atualizar CA"
              class="q-mt-sm btn"
              no-caps
              color="brand-1"
              icon="refresh"
              :disable="!caSelecionadoEditar"
              @click="atualizarValidadeCaSelecionado"
            >
            </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import CaValidationModal from "../../../components/CaValidationModal.vue";
import { useCaValidation } from "../../../composables/useCaValidation";

const columns = [
  {
    name: "codigoCa",
    label: "Código CA",
    align: "left",
    field: "code",
  },
  {
    name: "vencimento",
    label: "Vencimento",
    align: "left",
    field: "expires_in",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },

  {
    name: "btn",
    label: "Editar CA",
    align: "left",
  },
];
export default {
  components: {
    CaValidationModal,
  },
  props: {
    botaoTipo: String,
    status: String,
    caBusca: String,
  },

  setup(props) {
    const store = useStore();
    const quasar = useQuasar();
    const {
      isModalOpen,
      currentCaNumber,
      currentCaId,
      openValidationModal,
      closeValidationModal,
      onCaUpdated,
    } = useCaValidation();
    const time = ref();
    const listaCas = ref([]);
    const options = ref([]);
    const timer = ref(null);
    const timer2 = ref(null);
    const modalCa = ref(false);
    const modoModal = ref("criar"); // 'criar' ou 'editar'
    const caSelecionadoEditar = ref(null); // usado no modo editar
    let caAtualizar = ref(null);

    const busca = ref("");
    const dados = ref({
      dataAtualizar: "",
      codigo: "",
      dataExpiracao: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      // rowsNumber: 6,
    });
    const disable = ref(false);
    const loading = ref(false);

    const listarSelect = async (val) => {
      options.value = [];
      try {
        let response = await store.dispatch("produtos/listarCas", {
          code: val,
          per_page: 15,
        });
        response.data.results.data.forEach((ca) => {
          options.value.push({
            value: ca.id,
            label: ca.code,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const listarCas = async (page = 1) => {
      loading.value = true;

      try {
        let response = await store.dispatch("produtos/listarCas", {
          per_page: 1000,
          page: page,
          search: busca.value,
          status: props.status?.value, // Filtro de status
          code: props.caBusca, // Filtro de código do CA
        });
        listaCas.value = response.data.results.data;
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const paginarTabela = async () => {
      listarCas(pagination.value.page, pagination.value.rowsPerPage);
    };

    const adicionarCA = async () => {
      if (dados.value.dataExpiracao == "" || dados.value.codigo == "") {
        quasar.notify({
          message: "Preencha todos os campos para adicionar um CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let data;

      data = dados.value.dataExpiracao;

      if (data) {
        let dia = dados.value.dataExpiracao.split("/")[0];
        let mes = dados.value.dataExpiracao.split("/")[1];
        let ano = dados.value.dataExpiracao.split("/")[2];

        data = ano + "-" + mes + "-" + dia;
      }
      try {
        await store.dispatch("produtos/adicionarCa", {
          code: dados.value.codigo,
          expires_in: `${data}T00:00:00.000Z`,
          format: "Y-m-d\\TH:i:s.u\\Z",
        });
        quasar.notify({
          message: "CA adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        dados.value.dataExpiracao = "";
        dados.value.codigo = "";
      } catch (error) {
        if (
          error.response?.data?.errors?.code[0] ===
          "code deve conter apenas números ou os caracteres /|-_"
        ) {
          quasar.notify({
            message:
              "O código deve conter apenas números ou os caracteres /|-_",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Erro ao adicionar CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => caAtualizar.value,
      () => {
        listarCas();
      }
    );

    watch(
      () => props.status,
      () => {
        listarCas();
      }
    );

    watch(
      () => props.caBusca,
      () => {
        listarCas();
      }
    );

    onMounted(listarCas);

    const abrirModalCriarCa = () => {
      modoModal.value = "criar";
      dados.value.codigo = "";
      dados.value.dataExpiracao = "";
      modalCa.value = true;
    };

    const abrirModalEditarCa = (ca) => {
      modoModal.value = "editar";
      caSelecionadoEditar.value = {
        value: ca.id,
        label: ca.code,
      };
      dados.value.dataAtualizar = ca.expires_in
        ?.split(" ")[0]
        ?.split("-")
        ?.reverse()
        ?.join("/");
      modalCa.value = true;
    };

    const atualizarValidadeCaSelecionado = async () => {
      if (!caSelecionadoEditar.value || dados.value.dataAtualizar === "") {
        quasar.notify({
          message: "Selecione um CA e preencha a validade",
          color: "negative",
        });
        return;
      }

      try {
        await store.dispatch("produtos/atualizarCa", {
          id: caSelecionadoEditar.value.value,
          code: caSelecionadoEditar.value.label,
          expires_in: dados.value.dataAtualizar,
        });

        modalCa.value = false;
        listarCas();
        quasar.notify({
          message: "CA atualizado com sucesso",
          color: "positive",
        });
      } catch (err) {
        console.error(err);
        quasar.notify({ message: "Erro ao atualizar CA", color: "negative" });
      }
    };
    return {
      columns,
      listaCas,
      listarSelect,
      timer,
      timer2,
      caAtualizar,
      filterFn(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarSelect(val);
        }, 2000);

        setTimeout(() => {
          update(() => {
            const needle = val.toLowerCase();
            options.value = options.value.filter((v) => {
              v.label.toLowerCase().indexOf(needle) > -1;
              return v;
            });
          });
        }, 2500);
      },
      dados,
      options,
      time,
      busca,
      // Funções de validação de CA
      validateCaNumber: (caCode, caId = null) => {
        if (!caCode) {
          quasar.notify({
            message: "Número do CA não encontrado",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        openValidationModal(caCode, caId);
      },
      handleCaUpdated: (updatedCa) => {
        // Recarrega a lista de CAs após atualização
        listarCas();
        onCaUpdated(updatedCa);
      },
      // Estados do modal
      isModalOpen,
      currentCaNumber,
      currentCaId,
      closeValidationModal,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      paginarTabela,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(listaCas.value.length / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      adicionarCA,
      modalCa,
      modoModal,
      caSelecionadoEditar,
      abrirModalCriarCa,
      abrirModalEditarCa,
      atualizarValidadeCaSelecionado,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .container-input {
    margin: 13px 0px 0px 0px;
  }
  .btn {
    font-size: 12px;
  }
  .container-table {
    margin: 40px 0px 0px 0px;
  }
  .titulo-table {
    display: none;
  }
  .input {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px 0px 0px;
  }
  .container-input-search {
    margin: 40px 0px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.titulo-input {
  color: #213864;
}
</style>
